import React, { FC, useEffect, useState, useContext } from 'react'
import isAuthenticated from '../../routes/isAuthenticated'
import { AbilityContext } from '../../config/Can'
import { AppAbility } from '../../config/ability'
import { Card, Container, Nav, Row, Tab } from 'react-bootstrap'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { useHistory, useRouteMatch } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import usePrevious from '../../hooks/usePrevious'
import RootState from '../../types/RootState'
import { getAccessibilities } from '../../redux/actions/accessibility'
import { getApplicationWelcomeAlert } from '../../redux/actions/applicationWelcomeAlert'
import { getServiceTypes } from '../../redux/actions/serviceType'
import { getTargetGroups } from '../../redux/actions/targetGroup'
import { getLanguages } from '../../redux/actions/language'
import { getOvernightCare } from '../../redux/actions/overnightCare'
import { getStaffingModel } from '../../redux/actions/staffingModel'
import { getWavierCompliant } from '../../redux/actions/wavierCompliant'
import { getCities, getStates, getCounties } from '../../redux/actions/location'
import {
  getProviderApplication, addProviderApplication, updateProviderApplicationGeneralInfo, updateProviderApplicationContactInfo, updateProviderApplicationOrgInfo, updateProviderApplicationDisclosureQuestions,
  updateProviderApplicationItem, updateProviderApplicationCertification, submitProviderApplication, submitCertificationItems
} from '../../redux/actions/providerApplication'
import { getEthnicity } from '../../redux/actions/ethnicity'
import { getRace } from '../../redux/actions/race'
import { getWeekDay, getDateWithoutTZOffset, getUploadModalData, getUploadType, getCardType, formatPhoneNumberSaved, getCertificationItemName } from '../../utils/dataTools'
import { getDomainName } from '../../utils/envVariables'
import { generateAddressOption } from '../../utils/smarty'
import Certification from '../../components/ApplicantDashboard/Certification'
import Application from '../../components/ApplicantDashboard/Application'
import Resource from '../../components/ApplicantDashboard/Resource'
import ActivityLog from '../../components/ApplicantDashboard/ActivityLog'
import GettingStartedModal from '../../components/Modals/GettingStartedModal'
import ProviderApplicationModal from '../../components/Modals/ProviderApplicationModal'
import ProviderAgreementModal from '../../components/Modals/ProviderAgreementModal'
import UploadModal from '../../components/Modals/UploadModal'
import OverrideValidationWarningModal from '../../components/Modals/OverrideValidationWarningModal'
import ProgressCard from '../../components/ApplicantDashboard/ProgressCard'
import RejectionNoteModal from '../../components/Modals/RejectionNoteModal'
import SubmitModal from '../../components/Modals/SubmitModal'
import request from 'superagent'

import './index.css'

interface Props {
  height: number;
  width: number;
}

interface MatchParams {
  applicationType: string;
  applicationTab: string;
}

const initialGeneralInfoState = {
  agencyName: '',
  legalEntity: '',
  serviceTypes: [],
  address: null,
  addressEntries: undefined,
  address1: '',
  address2: '',
  city: '',
  state: '',
  zipCode: '',
  overrideAddressValidation: null,
  contactFirstName: '',
  contactLastName: '',
  emailAddress: '',
  website: '',
  phoneNumber: '',
  extension: '',
  faxNumber: '',
  taxIdNumber: '',
  qualifier: '',
  npi: '',
  medicaidId: '',
  medicareId: '',
  providerAgencyId: '',
  billingName: '',
  billingAddress: null,
  billingEntries: undefined,
  billingAddress1: '',
  billingAddress2: '',
  billingCity: '',
  billingState: '',
  billingZipCode: '',
  billingOverrideAddressValidation: null,
  newBusiness: false,
  experienceYears: '',
  relevantExperience: '',
  targetGroups: [],
  accessibility: [],
  genderServed: '',
  languages: [],
  wavierCompliant: [],
  serviceDetails: '',
  counties: [],
  monday: false,
  mondayStart: null,
  mondayEnd: null,
  tuesday: false,
  tuesdayStart: null,
  tuesdayEnd: null,
  wednesday: false,
  wednesdayStart: null,
  wednesdayEnd: null,
  thursday: false,
  thursdayStart: null,
  thursdayEnd: null,
  friday: false,
  fridayStart: null,
  fridayEnd: null,
  saturday: false,
  saturdayStart: null,
  saturdayEnd: null,
  sunday: false,
  sundayStart: null,
  sundayEnd: null,
  holiday: '',
  residentialProviderApplicants: '',
  overnightCareId: null,
  staffingModel: null,
  handicappedAccessible: null,
  equityInclusionTraining: null,
  raceId: null,
  ethnicityId: null,
  publishRaceEthnicity: null,
}

const initialContactInfoState = {
  contractingId: null,
  contractingFirstName: '',
  contractingLastName: '',
  contractingPhoneNumber: '',
  contractingExtension: '',
  contractingFax: '',
  contractingEmailAddress: '',
  administratorId: null,
  administratorSameAsContracting: false,
  administratorFirstName: '',
  administratorLastName: '',
  administratorPhoneNumber: '',
  administratorExtension: '',
  administratorFax: '',
  administratorEmailAddress: '',
  billingId: null,
  billingSameAsContracting: false,
  billingFirstName: '',
  billingLastName: '',
  billingPhoneNumber: '',
  billingExtension: '',
  billingFax: '',
  billingEmailAddress: '',
  assessmentId: null,
  assessmentSameAsContracting: false,
  assessmentFirstName: '',
  assessmentLastName: '',
  assessmentPhoneNumber: '',
  assessmentExtension: '',
  assessmentFax: '',
  assessmentEmailAddress: '',
  qualityId: null,
  qualitySameAsContracting: false,
  qualityFirstName: '',
  qualityLastName: '',
  qualityPhoneNumber: '',
  qualityExtension: '',
  qualityFax: '',
  qualityEmailAddress: ''
}

const initialOrganizationalInfoState = {
  culturalCompetency: '',
  serviceLimitations: '',
  qualityAssurancePlan: '',
  trainingPlan: '',
  payLevelsAndBenefits: '',
  unintendedEventsPolicy: '',
  businessYears: ''
}

const initialDisclosureQuestionsState = {
  disclosureQuestion1: '',
  disclosureQuestion1Explanation: '',
  disclosureQuestion2: '',
  disclosureQuestion2Explanation: '',
  disclosureQuestion3: '',
  disclosureQuestion3Explanation: '',
  disclosureQuestion4: '',
  disclosureQuestion4Explanation: '',
  disclosureQuestion5: '',
  disclosureQuestion5Explanation: '',
  disclosureQuestion6: '',
  disclosureQuestion6Explanation: '',
  disclosureQuestion7: '',
  disclosureQuestion7Explanation: ''
}

const initialFiles = {
  w9Id: null,
  w9: [],
  w9File: null,
  facilityLicenseId: null,
  facilityLicense: [],
  facilityLicenseFile: null,
  doesNotHaveFacilityLicense: false,
  certificateInsuranceId: null,
  certificateInsurance: [],
  certificateInsuranceFile: null,
  debarmentAttestationLetterId: null,
  debarmentAttestationLetter: [],
  debarmentAttestationLetterFile: null,
  trainingAttestationLetterId: null,
  trainingAttestationLetter: [],
  trainingAttestationLetterFile: null,
  civilRightsComplianceAttestationLetterId: null,
  civilRightsComplianceAttestationLetter: [],
  doesNotApply: false,
  civilRightsComplianceAttestationLetterFile: null,
  residentialWorksheetId: null,
  residentialWorksheet: [],
  residentialWorksheetDoesNotApply: false,
  residentialWorksheetFile: null,
  certificationApplicationId: null,
  certificationApplication: [],
  certificationApplicationFile: null,
  individualQuestionnaireId: null,
  individualQuestionnaire: [],
  individualQuestionnaireFile: null,
  backgroundCheckId: null,
  backgroundCheck: [],
  backgroundCheckFile: null,
  proofOfInsuranceId: null,
  proofOfInsurance: [],
  proofOfInsuranceFile: null,
  referencesFormId: null,
  referencesForm: [],
  referencesFormFile: null,
  hcbsComplianceDocumentationId: null,
  hcbsComplianceDocumentation: [],
  hcbsComplianceDocumentationFile: null,
  leaseAgreementId: null,
  leaseAgreement: [],
  leaseAgreementFile: null,
  programStatementId: null,
  programStatement: [],
  programStatementFile: null,
  emergencyEvacuationPlanId: null,
  emergencyEvacuationPlan: [],
  emergencyEvacuationPlanFile: null,
  successionPlanningId: null,
  successionPlanning: [],
  successionPlanningFile: null,
  healthAttestationId: null,
  healthAttestation: [],
  healthAttestationFile: null,
  healthAssessmentId: null,
  healthAssessment: [],
  healthAssessmentFile: null,
  healthAssessmentNotApplicable: false,
  driversLicenseAttestationId: null,
  driversLicenseAttestation: [],
  driversLicenseAttestationFile: null,
  furnaceInspectionId: null,
  furnaceInspection: [],
  furnaceInspectionFile: null,
  fireInspectionId: null,
  fireInspection: [],
  fireInspectionFile: null,
  fireExtinguisherInvoiceId: null,
  fireExtinguisherInvoice: [],
  fireExtinguisherInvoiceFile: null,
  wellTestId: null,
  wellTest: [],
  wellTestFile: null,
  wellTestNotApplicable: false,
  fireDiagramId: null,
  fireDiagram: [],
  fireDiagramFile: null,
  governmentIssuedPhotoIdId: null,
  governmentIssuedPhotoId: [],
  governmentIssuedPhotoIdFile: null,
  petVaccinationsId: null,
  petVaccinations: [],
  petVaccinationsFile: null,
  petVaccinationsNotApplicable: false,
  prescriptionMedicationStoragePolicyId: null,
  prescriptionMedicationStoragePolicy: [],
  prescriptionMedicationStoragePolicyFile: null,
  medicationAdministrationPolicyId: null,
  medicationAdministrationPolicy: [],
  medicationAdministrationPolicyFile: null,
  trainingPlanId: null,
  trainingPlan: [],
  trainingPlanFile: null,
  proofOfCurrentTrainingId: null,
  proofOfCurrentTraining: [],
  proofOfCurrentTrainingFile: null,
  proofOfFinancesId: null,
  proofOfFinances: [],
  proofOfFinancesFile: null,
  backgroundCheckVerificationId: [],
  backgroundCheckVerification: [],
  backgroundCheckVerificationFiles: [],
  additionalDocuments: [],
  additionalDocumentsId: null,
  additionalDocumentsDoesNotApply: false,
  additionalDocumentsFile: [],
  removeFileList: [],
  applicationType: null
}

const ApplicantDashboard: FC<Props> = ({ height, width }: Props) => {
  const dispatch = useDispatch()
  const history = useHistory()
  const match = useRouteMatch<MatchParams>()
  const ability: AppAbility = useContext(AbilityContext)
  const token = localStorage.getItem('token') !== null && localStorage.getItem('token') !== 'undefined' ? JSON.parse(localStorage.getItem('token') || '') : ''

  // Override Address Validation
  const [isMulti, setIsMulti] = useState(false)
  const [overridingValidation, setOverridingValidation] = useState(false)
  const [showOverrideValidationWarningModal, setShowOverrideValidationWarningModal] = useState(false)
  const [submitValues, setSubmitValues] = useState(null)

  // Redux data
  const {
    user, providerApplication, providerApplicationResult, addProviderApplicationResult, updateGeneralInfo, updateContactInfo, updateOrgInfo, updateDisclosureQuestions, updateApplicationItem, updateApplicationCertification,
    submitApplication, submitCertification,
  } = useSelector((state: RootState) => ({
    user: state.authentication.user.data,
    providerApplication: state.providerApplication.providerApplication.data,
    providerApplicationResult: state.providerApplication.providerApplication,
    addProviderApplicationResult: state.providerApplication.addProviderApplication,
    updateGeneralInfo: state.providerApplication.updateGeneralInfo,
    updateContactInfo: state.providerApplication.updateContactInfo,
    updateOrgInfo: state.providerApplication.updateOrgInfo,
    updateDisclosureQuestions: state.providerApplication.updateDisclosureQuestions,
    updateApplicationItem: state.providerApplication.updateApplicationItem,
    updateApplicationCertification: state.providerApplication.updateApplicationCertification,
    submitApplication: state.providerApplication.submitApplication,
    submitCertification: state.providerApplication.submitCertification
  }))
  const isReadOnly = providerApplication?.status === "DENIED" || providerApplication?.status === "CLOSED";
  // Check if user can View this route
  useEffect(() => {
    if (ability.can('View', 'ProviderPortal')) {
      history.push('/')
    }
  }, [ability]) // eslint-disable-line react-hooks/exhaustive-deps

  // Page Tabs
  const [key, setKey] = useState('')
  const [isFirstLoad, setIsFirstLoad] = useState(true)

  // First time - Welcome Modal
  const [openGettingStarted, setOpenGettingStarted] = useState(false)
  const [addingProviderApplication, setAddingProviderApplication] = useState(false)

  // Check user data
  const prevUser: any = usePrevious(user)
  useEffect(() => {
    const token = localStorage.getItem('token') !== null && localStorage.getItem('token') !== 'undefined' ? JSON.parse(localStorage.getItem('token') || '') : ''
    if (prevUser !== user && user.user_id) {
      dispatch(getProviderApplication(user.user_id, token))
    }
  }, [user]) // eslint-disable-line react-hooks/exhaustive-deps

  // Check if user can View this route

  // Provider Application Form
  const [updatingProviderApplicationForm, setUpdatingProviderApplicationForm] = useState(false)

  // General Info
  const [generalInfoState, setGeneralInfoState] = useState(initialGeneralInfoState as any)
  const handleChangeGeneralInfoState = (values: any) => {
    setGeneralInfoState((previousState) => ({
      ...previousState,
      ...values
    }))
  }
  // Contact Info
  const [contactInfoState, setContactInfoState] = useState(initialContactInfoState as any)
  const handleChangeContactInfoState = (values: any) => {
    setContactInfoState((previousState) => ({
      ...previousState,
      ...values
    }))
  }
  // Organizational Info
  const [organizationalInfoState, setOrganizationalInfoState] = useState(initialOrganizationalInfoState)
  const handleChangeOrganizationalInfoState = (values: any) => {
    setOrganizationalInfoState((previousState) => ({
      ...previousState,
      ...values
    }))
  }
  // Disclosure Questions
  const [disclosureQuestionsState, setDisclosureQuestionsState] = useState(initialDisclosureQuestionsState)
  const handleChangeDisclosureQuestionsState = (values: any) => {
    setDisclosureQuestionsState((previousState) => ({
      ...previousState,
      ...values
    }))
  }

  // First time - Add new application
  const handleSubmitApplicationType = (values: any) => {
    dispatch(addProviderApplication(values, user.user_id, token))
    setAddingProviderApplication(true)
  }

  // First time - Check if provider application was added
  useEffect(() => {
    if (addProviderApplicationResult.success) {
      setOpenGettingStarted(false)
      setAddingProviderApplication(false)
    }
  }, [addProviderApplicationResult])

  // Application Modal
  const [applicationModal, setApplicationModal] = useState(false)

  // Agreement Modal
  const [agreementModal, setAgreementModal] = useState(false)
  const [agreementError, setAgreementError] = useState(false)
  const [submittingAgreement, setSubmittingAgreement] = useState(false)

  const handleSubmitProviderAgreement = () => {
    const providerAgreementItem = providerApplication.item.find((i) => i.modalType === 'agreement')
    request
      .get(`${getDomainName()}/api/providerApplicationItem/${providerAgreementItem?.providerApplicationItemId}`)
      .set('Accept', 'application/json')
      .set('access-token', token)
      .then((response) => {
        const { signed } = response.body
        if (!signed) {
          setAgreementError(true)
        } else {
          const dataBody = {
            providerApplicationItemId: providerAgreementItem?.providerApplicationItemId
          }
          dispatch(updateProviderApplicationItem(token, providerApplication.providerApplicationId, dataBody))
          setSubmittingAgreement(true)
        }
      })
      .catch(() => {
        setAgreementError(true)
      })
  }

  const handleCloseAgreementModal = () => {
    setAgreementModal(false)
    setSubmittingAgreement(false)
    setAgreementError(false)
  }

  // Upload Modal
  const [uploadModal, setUploadModal] = useState(false)
  const [uploadModalHeader, setUploadModalHeader] = useState('')
  const [uploadedFilesState, setUploadedFilesState] = useState(initialFiles as any)
  const [modalReadOnly, setModalReadOnly] = useState(false)
  const [uploadingDocument, setUploadingDocument] = useState(false)
  const handleOpenModal = (modalToOpen: string, modalHeader: string, readonly: boolean) => {
    if (modalToOpen === 'application') {
      setApplicationModal(true)
    } else if (modalToOpen === 'upload') {
      setUploadModal(true)
      setUploadModalHeader(getCertificationItemName(modalHeader))
    } else if (modalToOpen === 'agreement') {
      setAgreementModal(true)
    }
    setModalReadOnly(readonly)
  }

  const handleCloseApplication = () => {
    setApplicationModal(false)
    setTimeout(() => setUpdatingProviderApplicationForm(false))
    setIsMulti(false)
    setOverridingValidation(false)
    setShowOverrideValidationWarningModal(false)
    setSubmitValues(null)
  }

  const handleViewInstruction = (row: any) => {
    const domainName = getDomainName()
    if (row.status === 'CREATED') {
      const data = {
        providerApplicationCertificationId: row.providerApplicationCertificationId,
        modalType: row.modalType,
        file: null
      }

      const formData = new FormData()
      Object.keys(data).forEach((key) => {
        if (data[key]) {
          formData.append(key, data[key])
        }
      })
      dispatch(updateProviderApplicationCertification(token, providerApplication.providerApplicationId, formData))
    }
    // Open document
    window.open(`${domainName}/pdf/providerapplication/certification/${row.certificationType}${row.certificationType.includes('Instruction') ? '.docx' : '.pdf'}`)
  }

  // Submit functionality
  const handleSubmitUploadFile = (values: any) => {
    const data = getUploadModalData(uploadModalHeader, values)
    const uploadType = getUploadType(uploadModalHeader)

    const formData = new FormData()
    Object.keys(data).forEach((key) => {
      if (data[key]) {
        if (key === 'file') {
          data[key].forEach((fileItem) => formData.append(key, fileItem))
        } else {
          formData.append(key, data[key])
        }
      }
    })

    setUploadingDocument(true)
    if (uploadType === 'item') {
      dispatch(updateProviderApplicationItem(token, providerApplication.providerApplicationId, formData))
    }

    if (uploadType === 'certification') {
      dispatch(updateProviderApplicationCertification(token, providerApplication.providerApplicationId, formData))
    }
  }

  const handleCloseUploadModal = () => {
    setUploadModal(false)
    setTimeout(() => setUploadingDocument(false))
  }

  const handleSubmitApplication = (values: any, step: number, submitItem: boolean = false) => {
    if (providerApplication.providerApplicationId) {
      setUpdatingProviderApplicationForm(true)
      if (step === 0) {
        dispatch(updateProviderApplicationGeneralInfo(token, providerApplication.providerApplicationId, values))
      } else if (step === 1) {
        dispatch(updateProviderApplicationContactInfo(token, providerApplication.providerApplicationId, {
          ...generalInfoState,
          ...values
        }))
      } else if (step === 2 && providerApplication.applicationType === 'residential') {
        dispatch(updateProviderApplicationOrgInfo(token, providerApplication.providerApplicationId, {
          ...generalInfoState,
          ...contactInfoState,
          ...values
        }))
      } else if ((step === 2 && providerApplication.applicationType === 'non-residential') || step === 3) {
        if (generalInfoState.overrideAddressValidation || generalInfoState.billingOverrideAddressValidation) {
          setIsMulti(generalInfoState.overrideAddressValidation && generalInfoState.billingOverrideAddressValidation)
          setSubmitValues({
            token,
            providerApplicationId: providerApplication.providerApplicationId,
            application: {
              ...generalInfoState,
              ...contactInfoState,
              ...organizationalInfoState,
              ...values,
              disclosureQuestion1: values.disclosureQuestion1 === '' ? null : values.disclosureQuestion1 === 'YES',
              disclosureQuestion2: values.disclosureQuestion2 === '' ? null : values.disclosureQuestion2 === 'YES',
              disclosureQuestion3: values.disclosureQuestion3 === '' ? null : values.disclosureQuestion3 === 'YES',
              disclosureQuestion4: values.disclosureQuestion4 === '' ? null : values.disclosureQuestion4 === 'YES',
              disclosureQuestion5: values.disclosureQuestion5 === '' ? null : values.disclosureQuestion5 === 'YES',
              disclosureQuestion6: values.disclosureQuestion6 === '' ? null : values.disclosureQuestion6 === 'YES',
              disclosureQuestion7: values.disclosureQuestion7 === '' ? null : values.disclosureQuestion7 === 'YES'
            },
            submitItem
          })
          setApplicationModal(false)
          setShowOverrideValidationWarningModal(true)
        } else {
          dispatch(
            updateProviderApplicationDisclosureQuestions(
              token,
              providerApplication.providerApplicationId, {
              ...generalInfoState,
              ...contactInfoState,
              ...organizationalInfoState,
              ...values,
              disclosureQuestion1: values.disclosureQuestion1 === '' ? null : values.disclosureQuestion1 === 'YES',
              disclosureQuestion2: values.disclosureQuestion2 === '' ? null : values.disclosureQuestion2 === 'YES',
              disclosureQuestion3: values.disclosureQuestion3 === '' ? null : values.disclosureQuestion3 === 'YES',
              disclosureQuestion4: values.disclosureQuestion4 === '' ? null : values.disclosureQuestion4 === 'YES',
              disclosureQuestion5: values.disclosureQuestion5 === '' ? null : values.disclosureQuestion5 === 'YES',
              disclosureQuestion6: values.disclosureQuestion6 === '' ? null : values.disclosureQuestion6 === 'YES',
              disclosureQuestion7: values.disclosureQuestion7 === '' ? null : values.disclosureQuestion7 === 'YES'
            },
              submitItem
            )
          )
        }
      }
    }
  }
  const { applicationTab } = match.params
  useEffect(() => {
    setKey(applicationTab)

    if (applicationTab === 'resources' || applicationTab === 'activitylog' || applicationTab === 'certification') {
      setIsFirstLoad(false)
    }
  }, [match.params]) // eslint-disable-line react-hooks/exhaustive-deps

  // Check if provider application exists
  const prevApplicationType: any = usePrevious((providerApplication && providerApplication.applicationType) || '')
  useEffect(() => {
    if (providerApplicationResult.success && !providerApplicationResult.loading) {
      if (!providerApplicationResult.data) {
        setOpenGettingStarted(true)
      } else { // Load provider application data
        if (isFirstLoad || (prevApplicationType !== providerApplication.applicationType)) {
          const { applicationTab } = match.params
          let keyFirstLoad = ''
          if (!applicationTab) {
            if (providerApplication && providerApplication.applicationType && providerApplication.applicationType === 'residential' && providerApplication['12BedCertification']) {
              keyFirstLoad = 'certification'
            } else {
              keyFirstLoad = 'application'
            }
          } else {
            keyFirstLoad = applicationTab
          }
          setKey(keyFirstLoad)
          setIsFirstLoad(false)
          history.push(`/applicant/${providerApplication.applicationType}/${keyFirstLoad}`)
        }

        // Load General Info data
        const generalContact = providerApplication.contact ? providerApplication.contact.find((contact) => contact.type && contact.type === 'General') : null
        const physicalAddress = providerApplication.address ? providerApplication.address.find((address) => address.addressType === 'Physical') : null
        const billingAddress = providerApplication.address ? providerApplication.address.find((address) => address.addressType === 'Billing') : null

        const operationHours = {}
        if (providerApplication.operationHours) {
          for (let i = 0; i < 7; i++) {
            const foundDay = providerApplication.operationHours.find((operationDay) => operationDay.day === i)
            const weekDay = getWeekDay(i)

            if (foundDay) {
              operationHours[`${weekDay}Id`] = foundDay.providerApplicationOperationHoursId || null
              operationHours[`${weekDay}`] = true
              if (!foundDay.startTime && !foundDay.endTime) {
                operationHours[`${weekDay}NA`] = true
                operationHours[`${weekDay}Start`] = null
                operationHours[`${weekDay}End`] = null
              } else {
                operationHours[`${weekDay}NA`] = false
                operationHours[`${weekDay}Start`] = foundDay.startTime ? getDateWithoutTZOffset(new Date(foundDay.startTime)) : null
                operationHours[`${weekDay}End`] = foundDay.endTime ? getDateWithoutTZOffset(new Date(foundDay.endTime)) : null
              }
            }
            else {
              operationHours[`${weekDay}`] = false
              operationHours[`${weekDay}Start`] = null
              operationHours[`${weekDay}End`] = null
            }
          }
        }

        setGeneralInfoState((previousState) => ({
          ...previousState,
          agencyName: providerApplication?.agencyName || '',
          legalEntity: providerApplication.legalEntity || '',
          serviceTypes: (providerApplication.serviceTypes && (providerApplication.serviceTypes.map(serviceType => serviceType.serviceTypeId))) || [],
          physicalAddressId: (physicalAddress && physicalAddress.providerApplicationAddressId) || null,
          address: physicalAddress ? generateAddressOption(physicalAddress) : null,
          address1: (physicalAddress && physicalAddress.address1) || '',
          address2: (physicalAddress && physicalAddress.address2) || '',
          city: (physicalAddress && physicalAddress.city) || '',
          state: (physicalAddress && physicalAddress.state) || '',
          zipCode: (physicalAddress && physicalAddress.zipCode) || '',
          overrideAddressValidation: physicalAddress ? physicalAddress.overrideAddressValidation : null,
          contactId: (generalContact && generalContact.providerApplicationContactId) || null,
          contactFirstName: (generalContact && generalContact.firstName) || '',
          contactLastName: (generalContact && generalContact.lastName) || '',
          emailAddress: (generalContact && generalContact.emailAddress) || '',
          website: providerApplication.website || '',
          phoneNumber: formatPhoneNumberSaved((generalContact && generalContact.phoneNumber) || ''),
          extension: (generalContact && generalContact.extension) || '',
          faxNumber: (generalContact && generalContact.faxNumber) || '',
          taxIdNumber: providerApplication.taxIdNumber || '',
          qualifier: providerApplication.qualifier || '',
          npi: providerApplication.npi || '',
          medicaidId: providerApplication.medicaidId || '',
          medicareId: providerApplication.medicareId || '',
          providerAgencyId: providerApplication.providerAgencyId || '',
          billingName: providerApplication.billingName || '',
          billingAddressId: (billingAddress && billingAddress.providerApplicationAddressId) || null,
          billingAddress: billingAddress ? generateAddressOption(billingAddress) : null,
          billingAddress1: (billingAddress && billingAddress.address1) || '',
          billingAddress2: (billingAddress && billingAddress.address2) || '',
          billingCity: (billingAddress && billingAddress.city) || '',
          billingState: (billingAddress && billingAddress.state) || '',
          billingZipCode: (billingAddress && billingAddress.zipCode) || '',
          billingOverrideAddressValidation: billingAddress ? billingAddress.overrideAddressValidation : null,
          newBusiness: providerApplication.newBusiness ? 'YES' : 'NO',
          experienceYears: providerApplication.experienceYears || '',
          relevantExperience: providerApplication.relevantExperience || '',
          targetGroups: (providerApplication.targetGroups && providerApplication.targetGroups.map(targetGroup => targetGroup.targetGroupId)) || [],
          accessibility: (providerApplication.accessibility && providerApplication.accessibility.map(accessibilityOpt => accessibilityOpt.accessibilityId)) || [],
          genderServed: providerApplication.genderServed || '',
          languages: (providerApplication.languages && providerApplication.languages.map(language => language.languageId)) || [],
          wavierCompliant: (providerApplication.wavierCompliant && providerApplication.wavierCompliant.map(compliant => compliant.homeCommunityCompliantId)) || [],
          serviceDetails: providerApplication.serviceDetails || '',
          counties: (providerApplication.counties && providerApplication.counties.reduce((acc, county) => (!county.serviced ? acc : [...acc, county.countyId]), [])) || [],
          ...operationHours,
          holiday: providerApplication.holiday || '',
          residentialProviderApplicants: providerApplication.residentialProviderApplicants || '',
          licensedCapacity: providerApplication.licensedCapacity || '',
          overnightCareId: providerApplication.overnightCareId || '',
          staffingModelId: providerApplication.staffingModelId || '',
          handicappedAccessible: providerApplication.handicappedAccessible || false,
          equityInclusionTraining: providerApplication.equityInclusionTraining || false,
          raceId: providerApplication.raceId,
          ethnicityId: providerApplication.ethnicityId,
          publishRaceEthnicity: providerApplication.publishRaceEthnicity,
        }))

        const contractingContact = providerApplication.contact ? providerApplication.contact.find((contact) => contact.type && contact.type.includes('Contracting')) : null
        const administratorContact = providerApplication.contact ? providerApplication.contact.find((contact) => contact.type && contact.type.includes('Administrator')) : null
        const billingContact = providerApplication.contact ? providerApplication.contact.find((contact) => contact.type && contact.type.includes('Billing')) : null
        const assessmentContact = providerApplication.contact ? providerApplication.contact.find((contact) => contact.type && contact.type.includes('Assessment')) : null
        const qualityContact = providerApplication.contact ? providerApplication.contact.find((contact) => contact.type && contact.type.includes('Quality')) : null

        // Set contact info data
        setContactInfoState({
          contractingId: (contractingContact && contractingContact.providerApplicationContactId) || null,
          contractingFirstName: (contractingContact && contractingContact.firstName) || '',
          contractingLastName: (contractingContact && contractingContact.lastName) || '',
          contractingPhoneNumber: formatPhoneNumberSaved((contractingContact && contractingContact.phoneNumber) || ''),
          contractingExtension: (contractingContact && contractingContact.extension) || '',
          contractingFax: (contractingContact && contractingContact.faxNumber) || '',
          contractingEmailAddress: (contractingContact && contractingContact.emailAddress) || '',
          administratorId: (administratorContact && administratorContact.providerApplicationContactId) || null,
          administratorSameAsContracting: false,
          administratorFirstName: (administratorContact && administratorContact.firstName) || '',
          administratorLastName: (administratorContact && administratorContact.lastName) || '',
          administratorPhoneNumber: formatPhoneNumberSaved((administratorContact && administratorContact.phoneNumber) || ''),
          administratorExtension: (administratorContact && administratorContact.extension) || '',
          administratorFax: (administratorContact && administratorContact.faxNumber) || '',
          administratorEmailAddress: (administratorContact && administratorContact.emailAddress) || '',
          billingId: (billingContact && billingContact.providerApplicationContactId) || null,
          billingSameAsContracting: false,
          billingFirstName: (billingContact && billingContact.firstName) || '',
          billingLastName: (billingContact && billingContact.lastName) || '',
          billingPhoneNumber: formatPhoneNumberSaved((billingContact && billingContact.phoneNumber) || ''),
          billingExtension: (billingContact && billingContact.extension) || '',
          billingFax: (billingContact && billingContact.faxNumber) || '',
          billingEmailAddress: (billingContact && billingContact.emailAddress) || '',
          assessmentId: (assessmentContact && assessmentContact.providerApplicationContactId) || null,
          assessmentSameAsContracting: false,
          assessmentFirstName: (assessmentContact && assessmentContact.firstName) || '',
          assessmentLastName: (assessmentContact && assessmentContact.lastName) || '',
          assessmentPhoneNumber: formatPhoneNumberSaved((assessmentContact && assessmentContact.phoneNumber) || ''),
          assessmentExtension: (assessmentContact && assessmentContact.extension) || '',
          assessmentFax: (assessmentContact && assessmentContact.faxNumber) || '',
          assessmentEmailAddress: (assessmentContact && assessmentContact.emailAddress) || '',
          qualityId: (qualityContact && qualityContact.providerApplicationContactId) || null,
          qualitySameAsContracting: false,
          qualityFirstName: (qualityContact && qualityContact.firstName) || '',
          qualityLastName: (qualityContact && qualityContact.lastName) || '',
          qualityPhoneNumber: formatPhoneNumberSaved((qualityContact && qualityContact.phoneNumber) || ''),
          qualityExtension: (qualityContact && qualityContact.extension) || '',
          qualityFax: (qualityContact && qualityContact.faxNumber) || '',
          qualityEmailAddress: (qualityContact && qualityContact.emailAddress) || ''
        })

        // Set organization info
        setOrganizationalInfoState({
          culturalCompetency: providerApplication.culturalCompetency || '',
          serviceLimitations: providerApplication.serviceLimitations || '',
          qualityAssurancePlan: providerApplication.qualityAssurancePlan || '',
          trainingPlan: providerApplication.trainingPlan || '',
          payLevelsAndBenefits: providerApplication.payLevelsAndBenefits || '',
          unintendedEventsPolicy: providerApplication.unintendedEventsPolicy || '',
          businessYears: providerApplication.businessYears || ''
        })

        // Set disclosure questions
        setDisclosureQuestionsState({
          disclosureQuestion1: providerApplication.disclosureQuestion1 === null ? '' : (providerApplication.disclosureQuestion1 ? 'YES' : 'NO'),
          disclosureQuestion1Explanation: providerApplication.disclosureQuestion1Explanation || '',
          disclosureQuestion2: providerApplication.disclosureQuestion2 === null ? '' : (providerApplication.disclosureQuestion2 ? 'YES' : 'NO'),
          disclosureQuestion2Explanation: providerApplication.disclosureQuestion2Explanation || '',
          disclosureQuestion3: providerApplication.disclosureQuestion3 === null ? '' : (providerApplication.disclosureQuestion3 ? 'YES' : 'NO'),
          disclosureQuestion3Explanation: providerApplication.disclosureQuestion3Explanation || '',
          disclosureQuestion4: providerApplication.disclosureQuestion4 === null ? '' : (providerApplication.disclosureQuestion4 ? 'YES' : 'NO'),
          disclosureQuestion4Explanation: providerApplication.disclosureQuestion4Explanation || '',
          disclosureQuestion5: providerApplication.disclosureQuestion5 === null ? '' : (providerApplication.disclosureQuestion5 ? 'YES' : 'NO'),
          disclosureQuestion5Explanation: providerApplication.disclosureQuestion5Explanation || '',
          disclosureQuestion6: providerApplication.disclosureQuestion6 === null ? '' : (providerApplication.disclosureQuestion6 ? 'YES' : 'NO'),
          disclosureQuestion6Explanation: providerApplication.disclosureQuestion6Explanation || '',
          disclosureQuestion7: providerApplication.disclosureQuestion7 === null ? '' : (providerApplication.disclosureQuestion7 ? 'YES' : 'NO'),
          disclosureQuestion7Explanation: providerApplication.disclosureQuestion7Explanation || ''
        })

        // Application items
        const w9Item = providerApplication.item ? providerApplication.item.find((item) => item.itemType && item.itemType.includes('Copy of W-9')) : null
        const facilityLicenseItem = providerApplication.item ? providerApplication.item.find((item) => item.itemType && item.itemType.includes('Copy of Facility Licensure')) : null
        const certificateInsuranceItem = providerApplication.item ? providerApplication.item.find((item) => item.itemType && item.itemType.includes('Copy of Certificate of Insurance')) : null
        const debarmentAttestationLetterItem = providerApplication.item ? providerApplication.item.find((item) => item.itemType && item.itemType.includes('Debarment Attestation Letter')) : null
        const trainingAttestationLetterItem = providerApplication.item ? providerApplication.item.find((item) => item.itemType && item.itemType.includes('Training Attestation Letter')) : null
        const civilRightsComplianceAttestationLetterItem = providerApplication.item ? providerApplication.item.find((item) => item.itemType && item.itemType.includes('Civil Rights Compliance Attestation Letter')) : null
        const residentialWorksheetItem = providerApplication.item ? providerApplication.item.find((item) => item.itemType && item.itemType.includes('Residential Worksheets')) : null
        const backgroundCheckVerificationItem = providerApplication.item ? providerApplication.item.find((item) => item.itemType && item.itemType.includes('Background Check Verification')) : null
        const additionalDocumentsItem = providerApplication.item ? providerApplication.item.find((item) => item.itemType && item.itemType.includes('Additional Documents')) : null

        // Application certifications
        const certificationApplicationItem = providerApplication.certification ? providerApplication.certification.find((item) => item.certificationType && item.certificationType.includes('Certification Application')) : null
        const individualQuestionnaireItem = providerApplication.certification ? providerApplication.certification.find((item) => item.certificationType && item.certificationType.includes('Individual Questionnaire')) : null
        const backgroundCheckItem = providerApplication.certification ? providerApplication.certification.find((item) => item.certificationType && item.certificationType.includes('Background Check (BID)')) : null
        const proofOfInsuranceItem = providerApplication.certification ? providerApplication.certification.find((item) => item.certificationType && item.certificationType.includes('Proof of Insurance')) : null
        const referencesFormItem = providerApplication.certification ? providerApplication.certification.find((item) => item.certificationType && item.certificationType.includes('Personal Reference Form')) : null
        const hcbsComplianceDocumentationItem = providerApplication.certification ? providerApplication.certification.find((item) => item.certificationType && item.certificationType.includes('HCBS Compliance Documentation')) : null
        const leaseAgreementItem = providerApplication.certification ? providerApplication.certification.find((item) => item.certificationType && item.certificationType.includes('Lease Agreement')) : null
        const programStatementItem = providerApplication.certification ? providerApplication.certification.find((item) => item.certificationType && item.certificationType.includes('Program Statement')) : null
        const emergencyEvacuationPlanItem = providerApplication.certification ? providerApplication.certification.find((item) => item.certificationType && item.certificationType.includes('Emergency Evacuation Plan')) : null
        const successionPlanningItem = providerApplication.certification ? providerApplication.certification.find((item) => item.certificationType && item.certificationType.includes('Succession Planning')) : null
        const healthAttestationItem = providerApplication.certification ? providerApplication.certification.find((item) => item.certificationType && item.certificationType.includes('Health Attestation')) : null
        const healthAssessmentItem = providerApplication.certification ? providerApplication.certification.find((item) => item.certificationType && item.certificationType.includes('Health Assessment')) : null
        const driversLicenseAttestationItem = providerApplication.certification ? providerApplication.certification.find((item) => item.certificationType && item.certificationType.includes('Driver\'s License Attestation')) : null
        const furnaceInspectionItem = providerApplication.certification ? providerApplication.certification.find((item) => item.certificationType && item.certificationType.includes('Furnace Inspection')) : null
        const fireInspectionItem = providerApplication.certification ? providerApplication.certification.find((item) => item.certificationType && item.certificationType.includes('Fire Inspection')) : null
        const fireExtinguisherInvoiceItem = providerApplication.certification ? providerApplication.certification.find((item) => item.certificationType && item.certificationType.includes('Fire Extinguisher Invoice')) : null
        const wellTestItem = providerApplication.certification ? providerApplication.certification.find((item) => item.certificationType && item.certificationType.includes('Well Test')) : null
        const fireDiagramItem = providerApplication.certification ? providerApplication.certification.find((item) => item.certificationType && item.certificationType.includes('Fire Diagram')) : null
        const governmentIssuedPhotoIdItem = providerApplication.certification ? providerApplication.certification.find((item) => item.certificationType && item.certificationType.includes('Government Issued Photo ID')) : null
        const petVaccinationsItem = providerApplication.certification ? providerApplication.certification.find((item) => item.certificationType && item.certificationType.includes('Pet Vaccinations')) : null
        const prescriptionMedicationStoragePolicyItem = providerApplication.certification ? providerApplication.certification.find((item) => item.certificationType && item.certificationType.includes('Prescription Medication Storage Policy')) : null
        const medicationAdministrationPolicyItem = providerApplication.certification ? providerApplication.certification.find((item) => item.certificationType && item.certificationType.includes('Medication Administration Policy')) : null
        const trainingPlanItem = providerApplication.certification ? providerApplication.certification.find((item) => item.certificationType && item.certificationType.includes('Training Plan')) : null
        const proofOfCurrentTrainingItem = providerApplication.certification ? providerApplication.certification.find((item) => item.certificationType && item.certificationType.includes('Proof of Current Training')) : null
        const proofOfFinancesItem = providerApplication.certification ? providerApplication.certification.find((item) => item.certificationType && item.certificationType.includes('Proof of Finances')) : null

        setUploadedFilesState({
          ...uploadedFilesState,
          w9Id: (w9Item && w9Item.providerApplicationItemId) || null,
          w9File: (w9Item && w9Item.attachment) || null,
          facilityLicenseId: (facilityLicenseItem && facilityLicenseItem.providerApplicationItemId) || null,
          doesNotHaveFacilityLicense: (facilityLicenseItem && facilityLicenseItem.notApplicable) || false,
          facilityLicenseFile: (facilityLicenseItem && facilityLicenseItem.attachment) || null,
          certificateInsuranceId: (certificateInsuranceItem && certificateInsuranceItem.providerApplicationItemId) || null,
          certificateInsuranceFile: (certificateInsuranceItem && certificateInsuranceItem.attachment) || null,
          debarmentAttestationLetterId: (debarmentAttestationLetterItem && debarmentAttestationLetterItem.providerApplicationItemId) || null,
          debarmentAttestationLetterFile: (debarmentAttestationLetterItem && debarmentAttestationLetterItem.attachment) || null,
          trainingAttestationLetterId: (trainingAttestationLetterItem && trainingAttestationLetterItem.providerApplicationItemId) || null,
          trainingAttestationLetterFile: (trainingAttestationLetterItem && trainingAttestationLetterItem.attachment) || null,
          civilRightsComplianceAttestationLetterId: (civilRightsComplianceAttestationLetterItem && civilRightsComplianceAttestationLetterItem.providerApplicationItemId) || null,
          civilRightsComplianceAttestationLetterFile: (civilRightsComplianceAttestationLetterItem && civilRightsComplianceAttestationLetterItem.attachment) || null,
          doesNotApply: (civilRightsComplianceAttestationLetterItem && civilRightsComplianceAttestationLetterItem.notApplicable) || false,
          residentialWorksheetId: (residentialWorksheetItem && residentialWorksheetItem.providerApplicationItemId) || null,
          residentialWorksheetDoesNotApply: (residentialWorksheetItem && residentialWorksheetItem.notApplicable) || false,
          residentialWorksheetFile: (residentialWorksheetItem && residentialWorksheetItem.attachment) || false,
          certificationApplicationId: (certificationApplicationItem && certificationApplicationItem.providerApplicationCertificationId) || null,
          certificationApplicationFile: (certificationApplicationItem && certificationApplicationItem.attachment) || null,
          individualQuestionnaireId: (individualQuestionnaireItem && individualQuestionnaireItem.providerApplicationCertificationId) || null,
          individualQuestionnaireFile: (individualQuestionnaireItem && individualQuestionnaireItem.attachment) || null,
          backgroundCheckId: (backgroundCheckItem && backgroundCheckItem.providerApplicationCertificationId) || null,
          backgroundCheckFile: (backgroundCheckItem && backgroundCheckItem.attachment) || null,
          proofOfInsuranceId: (proofOfInsuranceItem && proofOfInsuranceItem.providerApplicationCertificationId) || null,
          proofOfInsuranceFile: (proofOfInsuranceItem && proofOfInsuranceItem.attachment) || null,
          referencesFormId: (referencesFormItem && referencesFormItem.providerApplicationCertificationId) || null,
          referencesFormFile: (referencesFormItem && referencesFormItem.attachment) || null,
          hcbsComplianceDocumentationId: (hcbsComplianceDocumentationItem && hcbsComplianceDocumentationItem.providerApplicationCertificationId) || null,
          hcbsComplianceDocumentationFile: (hcbsComplianceDocumentationItem && hcbsComplianceDocumentationItem.attachment) || null,
          leaseAgreementId: (leaseAgreementItem && leaseAgreementItem.providerApplicationCertificationId) || null,
          leaseAgreementFile: (leaseAgreementItem && leaseAgreementItem.attachment) || null,
          programStatementId: (programStatementItem && programStatementItem.providerApplicationCertificationId) || null,
          programStatementFile: (programStatementItem && programStatementItem.attachment) || null,
          emergencyEvacuationPlanId: (emergencyEvacuationPlanItem && emergencyEvacuationPlanItem.providerApplicationCertificationId) || null,
          emergencyEvacuationPlanFile: (emergencyEvacuationPlanItem && emergencyEvacuationPlanItem.attachment) || null,
          successionPlanningId: (successionPlanningItem && successionPlanningItem.providerApplicationCertificationId) || null,
          successionPlanningFile: (successionPlanningItem && successionPlanningItem.attachment) || null,
          healthAttestationId: (healthAttestationItem && healthAttestationItem.providerApplicationCertificationId) || null,
          healthAttestationFile: (healthAttestationItem && healthAttestationItem.attachment) || null,
          healthAssessmentId: (healthAssessmentItem && healthAssessmentItem.providerApplicationCertificationId) || null,
          healthAssessmentNotApplicable: (healthAssessmentItem && healthAssessmentItem.notApplicable) || false,
          healthAssessmentFile: (healthAssessmentItem && healthAssessmentItem.attachment) || false,
          driversLicenseAttestationId: (driversLicenseAttestationItem && driversLicenseAttestationItem.providerApplicationCertificationId) || null,
          driversLicenseAttestationFile: (driversLicenseAttestationItem && driversLicenseAttestationItem.attachment) || null,
          furnaceInspectionId: (furnaceInspectionItem && furnaceInspectionItem.providerApplicationCertificationId) || null,
          furnaceInspectionFile: (furnaceInspectionItem && furnaceInspectionItem.attachment) || null,
          fireInspectionId: (fireInspectionItem && fireInspectionItem.providerApplicationCertificationId) || null,
          fireInspectionFile: (fireInspectionItem && fireInspectionItem.attachment) || null,
          fireExtinguisherInvoiceId: (fireExtinguisherInvoiceItem && fireExtinguisherInvoiceItem.providerApplicationCertificationId) || null,
          fireExtinguisherInvoiceFile: (fireExtinguisherInvoiceItem && fireExtinguisherInvoiceItem.attachment) || null,
          wellTestId: (wellTestItem && wellTestItem.providerApplicationCertificationId) || null,
          wellTestNotApplicable: (wellTestItem && wellTestItem.notApplicable) || false,
          wellTestFile: (wellTestItem && wellTestItem.attachment) || false,
          fireDiagramId: (fireDiagramItem && fireDiagramItem.providerApplicationCertificationId) || null,
          fireDiagramFile: (fireDiagramItem && fireDiagramItem.attachment) || null,
          governmentIssuedPhotoIdId: (governmentIssuedPhotoIdItem && governmentIssuedPhotoIdItem.providerApplicationCertificationId) || null,
          governmentIssuedPhotoIdFile: (governmentIssuedPhotoIdItem && governmentIssuedPhotoIdItem.attachment) || null,
          petVaccinationsId: (petVaccinationsItem && petVaccinationsItem.providerApplicationCertificationId) || null,
          petVaccinationsNotApplicable: (petVaccinationsItem && petVaccinationsItem.notApplicable) || false,
          petVaccinationsFile: (petVaccinationsItem && petVaccinationsItem.attachment) || false,
          prescriptionMedicationStoragePolicyId: (prescriptionMedicationStoragePolicyItem && prescriptionMedicationStoragePolicyItem.providerApplicationCertificationId) || null,
          prescriptionMedicationStoragePolicyFile: (prescriptionMedicationStoragePolicyItem && prescriptionMedicationStoragePolicyItem.attachment) || null,
          medicationAdministrationPolicyId: (medicationAdministrationPolicyItem && medicationAdministrationPolicyItem.providerApplicationCertificationId) || null,
          medicationAdministrationPolicyFile: (medicationAdministrationPolicyItem && medicationAdministrationPolicyItem.attachment) || null,
          trainingPlanId: (trainingPlanItem && trainingPlanItem.providerApplicationCertificationId) || null,
          trainingPlanFile: (trainingPlanItem && trainingPlanItem.attachment) || null,
          proofOfCurrentTrainingId: (proofOfCurrentTrainingItem && proofOfCurrentTrainingItem.providerApplicationCertificationId) || null,
          proofOfCurrentTrainingFile: (proofOfCurrentTrainingItem && proofOfCurrentTrainingItem.attachment) || null,
          proofOfFinancesId: (proofOfFinancesItem && proofOfFinancesItem.providerApplicationCertificationId) || null,
          proofOfFinancesFile: (proofOfFinancesItem && proofOfFinancesItem.attachment) || null,
          backgroundCheckVerificationId: (backgroundCheckVerificationItem && backgroundCheckVerificationItem.providerApplicationItemId) || null,
          backgroundCheckVerificationFiles: (backgroundCheckVerificationItem && backgroundCheckVerificationItem.backgroundCheck) || null,
          additionalDocumentsId: (additionalDocumentsItem && additionalDocumentsItem.providerApplicationItemId) || null,
          additionalDocumentsDoesNotApply: (additionalDocumentsItem && additionalDocumentsItem.notApplicable) || false,
          additionalDocumentsFile: (additionalDocumentsItem && additionalDocumentsItem.attachment) || false,
          applicationType: providerApplication.applicationType
        })
      }
    }
  }, [providerApplication, providerApplicationResult]) // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    const token = localStorage.getItem('token') !== null && localStorage.getItem('token') !== 'undefined' ? JSON.parse(localStorage.getItem('token') || '') : ''
    dispatch(getServiceTypes(token))
    dispatch(getCities(token))
    dispatch(getStates(token))
    dispatch(getCounties(token))
    dispatch(getTargetGroups(token))
    dispatch(getAccessibilities(token))
    dispatch(getLanguages(token))
    dispatch(getApplicationWelcomeAlert(token))
    dispatch(getWavierCompliant(token))
    dispatch(getOvernightCare(token))
    dispatch(getStaffingModel(token))
    dispatch(getEthnicity(token))
    dispatch(getRace(token))
  }, []) // eslint-disable-line react-hooks/exhaustive-deps

  const handleChangeTab = (key: string) => {
    setKey(key)
    history.push(`/applicant/${providerApplication.applicationType}/${key}`)
  }

  // Rejection note
  const [showRejectionNote, setShowRejectionNote] = useState(false)
  const [rejectionNoteTitle, setRejectionNoteTitle] = useState('')
  const [selectedRejectionNote, setSelectedRejectionNote] = useState('')
  const handleOpenRejectionNote = (item: any) => {
    const rejectionNote = item && item.rejectionNote[0]
    setShowRejectionNote(true)
    setSelectedRejectionNote((rejectionNote && rejectionNote.note) || '')
    setRejectionNoteTitle(getCertificationItemName(item.itemType || item.certificationType))
  }

  const handleCloseRejectionNote = () => {
    setShowRejectionNote(false)
    setSelectedRejectionNote('')
  }

  // Submit functionality
  const [showSubmitModal, setShowSubmitModal] = useState(false)
  const [submittingApplication, setSubmittingApplication] = useState(false)
  const handleSubmitApplicationItems = () => {
    const data = {
      userId: user.user_id
    }
    if (key === 'certification') {
      dispatch(submitCertificationItems(token, providerApplication.providerApplicationId, data))
    } else {
      dispatch(submitProviderApplication(token, providerApplication.providerApplicationId, data))
    }
    setSubmittingApplication(true)
  }

  const handleCloseSubmitModal = () => {
    setShowSubmitModal(false)
    setSubmittingApplication(false)
  }

  const progress = providerApplication && key === 'certification' ? (
    providerApplication && providerApplication.certificationProgress && providerApplication.certificationTotal ? (providerApplication.certificationProgress * 100) / providerApplication.certificationTotal : 0
  ) : (
    providerApplication && providerApplication.itemProgress && providerApplication.itemTotal ? (providerApplication.itemProgress * 100) / providerApplication.itemTotal : 0
  )

  // Override Address Validation
  const handleCloseOverrideValidationModal = () => {
    setIsMulti(false)
    setOverridingValidation(false)
    setShowOverrideValidationWarningModal(false)
    setSubmitValues(null)
  }

  const handleSubmitOverrideValidation = () => {
    dispatch(
      updateProviderApplicationDisclosureQuestions(
        submitValues.token,
        submitValues.providerApplicationId,
        submitValues.application,
        submitValues.submitItem
      )
    )
    setOverridingValidation(true)
  }

  const progressTitle = key === 'certification' ? 'Certification Items' : 'Application Completion'
  const cardType = getCardType(progress, (key === 'certification' ? providerApplication && providerApplication.certificationStatus : providerApplication && providerApplication.status))
  const cardHeight = cardType === 'started' ? -30 : (cardType === 'in progress' ? -8 : 0)
  return (
    <Container
      style={{
        paddingTop: 20,
        backgroundColor: '#f5f5f5',
        width: width,
        height: height - 20,
        maxWidth: width,
        overflowY: 'auto',
        overflowX: 'hidden'
      }}
    >
      <Row>
        <div className='applicant-header'>
          <div className='applicant-header-txt'>
            <div className='applicant-icon'>
              <FontAwesomeIcon icon={['fas', 'file-alt']} size='3x' />
            </div>
            <div className='applicant-txt'>
              <h4>Applicant Dashboard</h4>
            </div>
          </div>
          <ProgressCard
            cardType={cardType}
            isCertification={key === 'certification'}
            progress={progress}
            progressTitle={progressTitle}
            onSubmit={() => setShowSubmitModal(true)}
          />
        </div>
      </Row>
      <Row>
        <Tab.Container id='applicant-tab' activeKey={key} onSelect={(key: any) => handleChangeTab(key)}>
          <Card style={{ border: 'none', width, height: height - 130 + cardHeight }}>
            <Card.Header>
              <Nav variant='tabs'>
                {
                  providerApplication && providerApplication.applicationType === 'residential' && providerApplication['12BedCertification'] ? (
                    <Nav.Item className='applicant-nav-item'>
                      <Nav.Link eventKey='certification'><b>Certification</b></Nav.Link>
                    </Nav.Item>
                  ) : null
                }
                <Nav.Item className='applicant-nav-item'>
                  <Nav.Link eventKey='application'><b>Application</b></Nav.Link>
                </Nav.Item>
                <Nav.Item className='applicant-nav-item'>
                  <Nav.Link eventKey='resources'><b>Resources</b></Nav.Link>
                </Nav.Item>
                <Nav.Item className='applicant-nav-item'>
                  <Nav.Link eventKey='activitylog'><b>Activity Log</b></Nav.Link>
                </Nav.Item>
              </Nav>
            </Card.Header>
            <Card.Body className='applicant-card-body'>
              <Tab.Content>
                <Tab.Pane eventKey='certification'>
                  <Certification
                    providerApplication={providerApplication}
                    onOpenModal={handleOpenModal}
                    readOnly={isReadOnly}
                    onOpenRejectionNote={handleOpenRejectionNote}
                    onViewInstruction={handleViewInstruction}
                  />
                </Tab.Pane>
                <Tab.Pane eventKey='application'>
                  <Application
                    providerApplication={providerApplication}
                    onOpenModal={handleOpenModal}
                    readOnly={isReadOnly}
                    onOpenRejectionNote={handleOpenRejectionNote}
                  />
                  <ProviderApplicationModal
                    show={applicationModal}
                    applicationType={providerApplication ? providerApplication.applicationType : ''}
                    updatingProviderApplicationForm={updatingProviderApplicationForm}
                    generalInfoState={generalInfoState}
                    updateGeneralInfo={updateGeneralInfo}
                    onChangeGeneralInfoState={handleChangeGeneralInfoState}
                    contactInfoState={contactInfoState}
                    updateContactInfo={updateContactInfo}
                    onChangeContactInfoState={handleChangeContactInfoState}
                    organizationalInfoState={organizationalInfoState}
                    updateOrgInfo={updateOrgInfo}
                    onChangeOrganizationalInfoState={handleChangeOrganizationalInfoState}
                    disclosureQuestionsState={disclosureQuestionsState}
                    updateDisclosureQuestions={updateDisclosureQuestions}
                    readonly={modalReadOnly}
                    onChangeDisclosureQuestionsState={handleChangeDisclosureQuestionsState}
                    onClose={handleCloseApplication}
                    onSubmit={handleSubmitApplication}
                  />
                  <OverrideValidationWarningModal
                    isMulti={isMulti}
                    saveText='You have submitted your Provider Application Form.'
                    show={showOverrideValidationWarningModal}
                    savingInProgress={overridingValidation}
                    state={updateDisclosureQuestions}
                    title='Provider Application'
                    onAction={handleSubmitOverrideValidation}
                    onClose={handleCloseOverrideValidationModal}
                  />
                  <ProviderAgreementModal
                    readOnly={modalReadOnly}
                    show={agreementModal}
                    user={user}
                    item={providerApplication && providerApplication.item.find((i) => i.modalType === 'agreement')}
                    height={height}
                    width={width}
                    updateApplicationItem={updateApplicationItem}
                    error={agreementError}
                    submittingAgreement={submittingAgreement}
                    onSubmit={handleSubmitProviderAgreement}
                    onClose={handleCloseAgreementModal}
                  />
                </Tab.Pane>
                <Tab.Pane eventKey='resources'>
                  <Resource resources={!providerApplication || (providerApplication && !providerApplication.resources) ? [] : providerApplication.resources} />
                </Tab.Pane>
                <Tab.Pane eventKey='activitylog'>
                  <ActivityLog
                    activities={!providerApplication || (providerApplication && !providerApplication.activity) ? [] : providerApplication.activity}
                  />
                </Tab.Pane>
              </Tab.Content>
            </Card.Body>
          </Card>
        </Tab.Container>
      </Row>
      <UploadModal
        show={uploadModal}
        modalHeader={uploadModalHeader}
        readonly={modalReadOnly}
        state={{
          ...uploadedFilesState,
          modalType: uploadModalHeader
        }}
        uploadingDocument={uploadingDocument}
        updateApplicationItem={updateApplicationItem}
        updateApplicationCertification={updateApplicationCertification}
        onClose={handleCloseUploadModal}
        onSubmit={handleSubmitUploadFile}
      />
      <GettingStartedModal
        addingProviderApplication={addingProviderApplication}
        addProviderApplication={addProviderApplicationResult}
        show={openGettingStarted}
        onSubmit={(values) => handleSubmitApplicationType(values)}
      />
      <RejectionNoteModal
        modalTitle={rejectionNoteTitle}
        note={selectedRejectionNote}
        show={showRejectionNote}
        onClose={handleCloseRejectionNote}
      />
      <SubmitModal
        isCertification={key === 'certification'}
        show={showSubmitModal}
        state={key === 'certification' ? submitCertification : submitApplication}
        submittingApplication={submittingApplication}
        onSubmit={handleSubmitApplicationItems}
        onClose={handleCloseSubmitModal}
      />
    </Container>
  )
}

export default isAuthenticated(ApplicantDashboard)